// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"ce371fff","198":"bb2b7b48","313":"a5ad2e36","431":"f221551c"}[chunkId] + ".chunk.css";
};